import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css']
})
export class AboutUsComponent implements OnInit {

  constructor(private meta: Meta, private title: Title) { }

  ngOnInit(): void {
    this.metaTagAdd()  //////  Meta tags add for SEO  //////
  }
  metaTagAdd() {
    this.title.setTitle('About Us | My Yatra 360');

    this.meta.updateTag({
      name: 'description',
      content: 'Discover the vision, mission, and team behind My Yatra 360. We’re passionate about creating memorable travel experiences powered by innovation.'
    });

    this.meta.updateTag({
      name: 'keywords',
      content: 'About Us'
    });
  }
}
